import React, {useEffect, useState, useContext} from "react";
import {Routes, Route} from "react-router-dom";
import {AuthContext} from "./contexts/AuthContext";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import VerifyEmailInfo from "./pages/VerifyEmailInfo";
import Form from "./pages/Form";
import PrivateRoute from "./components/PrivateRoute";
import Landing from "./pages/Landing";
import Collections from "./pages/Collections";
import Products from "./pages/Products";
import Finished from "./pages/Finished";
import Archived from "./pages/Archived";
import Publications from "./pages/Publications";
import InventoryProducts from "./pages/InventoryProducts";
import InventoryCollections from "./pages/InventoryCollections";
import Drops from "./pages/Drops";
import Preorders from "./pages/Preorders";
import Orders from "./pages/Orders";

function App() {
    const { isAuthLoading } = useContext(AuthContext);
    const [sidebarWidth, setSidebarWidth] = useState(0);
    useEffect(() => {
        setSidebarWidth(document.querySelector('.sidebar')?.clientWidth)
        window.addEventListener('resize', () => {
            setSidebarWidth(document.querySelector('.sidebar')?.clientWidth)
        });
        window.addEventListener('sidebarResize', () => {
            setSidebarWidth(document.querySelector('.sidebar')?.clientWidth)
        });
    }, []);
    // if (isAuthLoading) {
    //     return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>Chargement de l'authentification...</div>;
    // }
    return <div className="App">
            <Navbar/>
            <div className="content">
                <Sidebar/>
                <Routes>
                    <Route path="/" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Landing/></div>}/>
                    <Route path="/login" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Login/></div>}/>
                    <Route path="/register" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Register/></div>}/>
                    <Route path="/verify-email-info" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><VerifyEmailInfo/></div>}/>
                    <Route path="/dashboard" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><div/></PrivateRoute></div>}/>
                    <Route path="/collections" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Collections/></PrivateRoute></div>}/>
                    <Route path="/products" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Products/></PrivateRoute></div>}/>
                    <Route path="/publications" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Publications/></PrivateRoute></div>}/>
                    <Route path="/orders" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Orders/></PrivateRoute></div>}/>
                    <Route path="/inventory/products" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><InventoryProducts/></PrivateRoute></div>}/>
                    <Route path="/inventory/collections" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><InventoryCollections/></PrivateRoute></div>}/>
                    <Route path="/inventory/drops" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Drops/></PrivateRoute></div>}/>
                    <Route path="/inventory/preorders" element={<div className="route" style={{
                        width: 'calc(100vw - 20px - '+sidebarWidth+'px)',
                    }}><PrivateRoute><Preorders/></PrivateRoute></div>}/>
                    <Route path="/form" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Form/></div>}/>
                    <Route path="/finished" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Finished/></div>}/>
                    <Route path="/archived" element={<div className="route landing" style={{
                        width: 'calc(100vw - '+sidebarWidth+'px)',
                    }}><Archived/></div>}/>
                </Routes>
            </div>
        </div>
}

export default App;
